import Comments from './comments';

export default {
  __init__: [ 'comments' ],
  'comments': [ 'type', Comments ]
};